<template>
  <div class="welfare-container">
    <div class="banner-container">
      <img src="../../../assets/images/welfare/banner.jpg" />
    </div>
    <p class="section-title-line">
      <span>新希望公益</span>
    </p>
    <div
      class="section-container intro-box-content"
      style="margin-bottom: 80px"
    >
      <p>新希望在发展中，一直身体力行，践行社会公益</p>
      <p>我们一直深信，优秀的企业从来不只是追逐利润，亦该肩负起社会责任</p>
      <p>
        同时促进公平竞争，推动环保实业，实现可持续发展目标，让人人都能分享经济发展成果
      </p>
      <p><br /></p>
      <p>新希望集团在刘永好董事长的带领下，从成立之初，就扛起“公益爱心大旗”</p>
      <p>
        从倡导“光彩事业”、帮扶农村走致富路、创建“博爱屋”，到支援汶川地震捐款
      </p>
      <p>三十多年来新希望从来没有停止过公益爱心行动</p>
    </div>

    <div class="section-container welfare-box">
      <el-row
        :gutter="20"
        class="wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="8">
          <div class="list-item">
            <div class="content-box">
              <div class="content-top">
                <p class="title">光彩事业</p>
                <p class="subheading">
                  1994年，时任全国工商联副主席的刘永好先生
                </p>
                <p class="subheading">
                  联合9位民营企业家，发起“光彩事业”倡议，
                </p>
                <p class="subheading">从此拉开了中国光彩事业的序幕。</p>
                <div class="line"></div>
                <div class="text">
                  <p>产业扶贫、精准扶贫</p>
                  <p>通过投资的方式，来带动就业，传递新的观念，</p>
                  <p>为老少边穷地区人们创造价值,</p>
                  <p>让当地农民成为新型的、有尊严的、富裕的农民。</p>
                </div>
              </div>
              <div class="content-bottom">
                <p>《光彩事业倡议书》</p>
                <div class="look_book" @click="go">点击阅读</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="img-box">
            <img src="../../../assets/images/welfare/1.jpg" alt="" />
          </div>
        </el-col>
      </el-row>

      <el-row
        :gutter="20"
        class="wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="16">
          <div class="img-box">
            <img src="../../../assets/images/welfare/2.jpg" alt="" />
          </div>
        </el-col>
        <el-col :span="8">
          <div class="list-item">
            <div class="content-box">
              <div class="content-top no-padding">
                <p class="title">小数据 大成绩</p>
                <div class="data-box">
                  <div class="data-item">
                    <div class="data-left-box">
                      <p>走过历程</p>
                      <p>24年</p>
                    </div>
                    <div>
                      <p>累计投资</p>
                      <p>50亿</p>
                    </div>
                  </div>
                  <div class="data-item">
                    <div>
                      <p>扶贫工厂遍布</p>
                      <p>14省</p>
                    </div>
                    <div class="data-left-box">
                      <p>创造就业岗位</p>
                      <p>6万</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

      <el-row
        :gutter="20"
        class="wow animate__slideInUp"
        data-wow-duration="500ms"
      >
        <el-col :span="8">
          <div style="margin-bottom: 0" class="list-item">
            <div class="content-box">
              <div class="content-top">
                <p class="title">公益志</p>
                <p class="subheading">
                  自1982创立，新希望集团一直秉持善念，身体力行,践行社会公益，履行社会责任，
                </p>
                <p class="subheading">
                  用点滴善举帮助贫困地区人民改善生活，改变命运。
                </p>
                <div class="line"></div>

                <div class="glory-img-box">
                  <div class="circle">
                    <div class="circle-item"></div>
                    <div class="circle-content circle-one">
                      <div>
                        <p>捐建光彩</p>
                        <p>事业小学</p>
                      </div>
                    </div>
                    <div class="circle-content circle-two">
                      <div>
                        <p>成立光彩</p>
                        <p>事业基金</p>
                      </div>
                    </div>
                    <div class="circle-content circle-three">
                      <div>
                        <p>定期公益行动</p>
                        <p>扶贫助贫</p>
                        <p></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="16">
          <div class="img-box">
            <img src="../../../assets/images/welfare/3.jpg" alt="" />
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "WelfarePage",
  data() {
    return {};
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    });
  },
  methods: {
    go() {
      window.open("http://www.newhopegroup.com/gcsy/index.html", "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.welfare-container {
  .list-item {
    margin-bottom: 20px;
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 440px;
    background-size: cover;
    background-position: center center;
  }

  .content-box {
    overflow: hidden;
    width: 100%;
    height: 440px;
    background: #265b38;
    opacity: 1;
    transition: all 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
  }

  .content-top {
    box-sizing: border-box;
    padding: 30px 34.5px 0;
    color: #fff;
    flex: 1;

    .title {
      font-size: 28px;
      font-weight: 400;
      color: #fff;
      margin-bottom: 15px;
    }

    .subheading {
      font-size: 14px;
      font-weight: 400;
      color: #fff;
      line-height: 24px;
    }

    .text {
      font-size: 13px;
      padding-top: 20px;
      color: #fff;
      width: 100%;
      line-height: 24px;
    }
  }

  .content-bottom {
    height: 136px;
    flex-shrink: 0;
    bottom: 0;
    background: #b1cc5b;
    box-sizing: border-box;
    padding: 30px 34.5px 0;
    color: #fff;

    > p:first-child {
      font-size: 20px;
    }

    .look_book {
      margin-top: 20px;
      width: 85px;
      height: 30px;
      border: 1px solid #fff;
      cursor: pointer;
      line-height: 30px;
      text-align: center;
      font-size: 13px;
    }
  }

  .img-box {
    height: 440px;
    width: 100%;
    overflow: hidden;
    > img {
      width: auto;
      height: 100%;
    }
  }

  .line {
    width: 30px;
    border-bottom: 1px solid #fff;
    margin-top: 20px;
  }

  .no-padding {
    padding: 0;

    > .title {
      margin-top: 30px;
      text-indent: 34.5px;
    }
  }

  .data-box {
    position: absolute;
    left: 0;
    height: 291px;
    width: 100%;
    top: 149px;

    > .data-item {
      overflow: hidden;
      height: 50%;

      > div {
        float: left;
        padding: 25px;
        box-sizing: border-box;
        width: 50%;
        height: 100%;
      }
    }

    .data-left-box {
      background-color: #377d4e;

      > p:nth-child(1) {
        font-size: 14px;
        color: #fff;
        font-weight: 400;
        margin-bottom: 20px;
      }

      > p:nth-child(2) {
        font-size: 28px;
        color: #fff;
      }
    }
  }

  .glory-img-box {
    margin-top: 17px;
    box-sizing: border-box;
    width: 100%;
    height: 240px;
    position: relative;
    padding-top: 44px;

    .circle {
      box-sizing: border-box;
      position: relative;
      width: 156px;
      height: 156px;
      border: 1px dashed #fff;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      padding: 20px;
      margin-left: auto;
      margin-right: auto;
    }

    .circle-item {
      position: absolute;
      width: 88%;
      height: 88%;
      left: 50%;
      top: 50%;
      margin-top: -44%;
      margin-left: -44%;
      border: 1px solid transparent;
      border-radius: 50%;
      -webkit-border-radius: 50%;
    }

    .circle-content {
      width: 88px;
      height: 88px;
      position: absolute;
      border-radius: 50%;
      -webkit-border-radius: 50%;
      -moz-border-radius: 50%;
      border: 1px solid #fff;
      background: #265b38;
      > div {
        margin: 24px 0;
        transform: scale(0.9);
        text-align: center;
        font-size: 13px;
        line-height: 17px;
        color: #fff;
      }
    }

    .circle-one {
      left: 50%;
      margin-left: -44px;
      margin-top: -57px;
    }

    .circle-two {
      bottom: -32%;
      left: -46%;
      margin-left: 36px;
      margin-bottom: 44px;
    }

    .circle-three {
      bottom: -32%;
      margin-bottom: 44px;
      right: -46%;
      margin-right: 28px;
    }
  }
}
</style>
